import { CartServiceI, CartItem } from '../../../index.d'
import { Api } from '../../api'

export class CartService implements CartServiceI {
  createCartItem(id: number, type: string): CartItem {
    return {
      resource_id: id,
      cart_item_type: type,
    }
  }

  async addCartItemToCart(cartItem: CartItem): Promise<unknown> {
    const { data } = await Api.post<unknown>(`/api/cart_items`, {
      cart_item: cartItem,
    })
    return data
  }
}
